import React from 'react'

import styles from './Separator.scss'

export default function Separator(props) {
  return (
    <span className={styles.separator} />
  )
}
